import { Box } from "@chakra-ui/react";
import { useContext } from "react";

import { OrganisationContext } from "../../providers/OrganisationProvider";
import { useThreediModelsByOwner } from "../../queries/threedimodels";

export function ModelListHelpText() {
  const { organisation } = useContext(OrganisationContext);
  const modelsResponse = useThreediModelsByOwner(organisation.uniqueId);

  return (
    <div>
      {modelsResponse.isSuccess ? (
        <p>
          <Box as="strong" textTransform="uppercase" color="brand.analytic">
            {modelsResponse.data?.count} Rana model(s) found.
          </Box>
        </p>
      ) : null}
      <p>
        A "Rana Model" is a revision of a schematisation that has been successfully prepared so that
        it can be used to run simulations with.
      </p>
    </div>
  );
}
